module.exports = "/_next/static/images/2b5b81cc9e69ccd2765f6c317b8c65c6-pj-man-holding-business-card@1x.jpg.webp";